import { render, staticRenderFns } from "./ListRastreamentoHistoricoView.vue?vue&type=template&id=281aa4dc&"
import script from "./ListRastreamentoHistoricoView.vue?vue&type=script&lang=ts&"
export * from "./ListRastreamentoHistoricoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports